import {useEffect, useState} from 'react';

// An image takes 25 to 100 seconds to generate (longer for a prompt describing the picture in detail):
// past this point the wait is expected, so the user gets a note about the generation time instead of a
// bare spinner.
const SLOW_GENERATION_HINT_DELAY_MS = 40_000;

export function useSlowGenerationHint(isGenerating: boolean): boolean {
    const [isSlowGeneration, setIsSlowGeneration] = useState<boolean>(false);

    useEffect(() => {
        if (!isGenerating) {
            setIsSlowGeneration(false);

            return;
        }

        const timeoutId = setTimeout(() => setIsSlowGeneration(true), SLOW_GENERATION_HINT_DELAY_MS);

        // eslint-disable-next-line consistent-return -- only the timer branch needs a cleanup
        return () => clearTimeout(timeoutId);
    }, [isGenerating]);

    return isSlowGeneration;
}
